import _ from 'lodash';

export function generateSourceSet(BREAKPOINTS, assets) {
  const set = [];
  _.forEach(assets, (value, key) => {
    if (_.isNil(value)) {
      return;
    }
    const breakpoint = BREAKPOINTS[key];
    set.push({ breakpoint: breakpoint, asset: value })
  });

  return _.reverse(set);
};